<div class="pagination" [class]="directionAxisValue">
<!--  <ng-template *ngIf="!itemContent; else itemContent;">-->
<!--    <button-->
<!--      class="pagination__item"-->
<!--      [class.pagination__item&#45;&#45;sequence]="btn.isMarked"-->
<!--      [class.pagination__item&#45;&#45;active]="btn.isActive"-->
<!--      *ngFor="let btn of paginationData"-->
<!--      (click)="clickOnPaginationItem(btn)"-->
<!--    >-->
<!--      <span>{{ btn.label }}</span>-->
<!--    </button>-->
<!--  </ng-template>-->
  <ng-container *ngTemplateOutlet="
  itemContent
  ? itemContent
  : defaultItem;
  context: {$implicit: {data: paginationData, onClick: clickOnPaginationItem.bind(this)}}"
  ></ng-container>

</div>

<ng-template #defaultItem>
  <button
    class="pagination__item"
    [class.pagination__item--sequence]="btn.isMarked"
    [class.pagination__item--active]="btn.isActive"
    *ngFor="let btn of paginationData"
    (click)="clickOnPaginationItem(btn)"
  >
    <span>{{ btn.label }}</span>
  </button>
</ng-template>
